import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import TourContainer from "../components/TourContainer/TourContainer";
function TourinMuslim(){
    return (
        <>
        <div className="TourinMuslim">
            <Navbar/>
            <TourContainer/>
            <Footer/>
        </div>
        </>
    )
}
export default TourinMuslim;